import { alpha } from '@mui/material/styles';
import {
  Box,
  Stack,
  Avatar,
  Skeleton,
  Typography,
} from '@mui/material';

import { useParams } from 'src/routes/hooks';

import { Iconify } from 'src/components/iconify';
import { useGetTournamentDivision } from 'src/api/tournaments';

export function DivisionInfo() {
  const { id = '', divisionId = '' } = useParams();

  const { division, divisionLoading } = useGetTournamentDivision(
    id,
    divisionId,
  );

  if (divisionLoading) {
    return (
      <Stack
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.1),
          width: '100%',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ width: 48, height: 48 }}>
            <Skeleton variant="circular" width={48} height={48} />
          </Box>
          <Stack direction="column" spacing={1}>
            <Skeleton width="70%" height={24} />
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton width={50} height={20} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    );
  }

  if (!division) {
    return (
      <Stack
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.1),
          width: '100%',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            sx={{
              width: 48,
              height: 48,
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
              border: (theme) =>
                `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            }}
          />
          <Stack direction="column" spacing={1}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 'fontWeightBold', lineHeight: 1.2 }}
            >
              division not found
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  width: 50,
                  height: 20,
                  bgcolor: 'background.neutral',
                  borderRadius: 1,
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.1),
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Avatar
          sx={{
            width: 48,
            height: 48,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
            border: (theme) =>
              `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Iconify icon="mdi:trophy" />
        </Avatar>

        <Stack direction="column" spacing={1}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'fontWeightBold', lineHeight: 1.2 }}
          >
            {division.name}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
